import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/pages/CierreMensual.css';
import { API_BASE_URL } from '../config';

const meses = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
];

const CierreMensual = ({ token, id_company }) => {
  const currentYear = new Date().getFullYear();
  const [anio, setAnio] = useState(currentYear);
  const [estado, setEstado] = useState({});
  const fetchEstado = async (year) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/cierre-mensual`, {
        params: { company: id_company, anio: year },
        headers: { Authorization: `Bearer ${token}` }
      });
      const map = {};
      res.data.forEach((r) => { map[r.mes] = r.cerrado; });
      setEstado(map);
    } catch (err) {
      console.error('Error al obtener cierre mensual:', err);
    }
  };
  useEffect(() => {
    if (id_company) fetchEstado(anio);
  }, [anio, id_company]);
  const toggleMes = async (mes) => {
    const cerrado = !estado[mes];
    try {
      await axios.post(`${API_BASE_URL}/api/cierre-mensual`, {
        company: id_company,
        anio,
        mes,
        cerrado
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEstado({ ...estado, [mes]: cerrado });
    } catch (err) {
      console.error('Error al actualizar cierre mensual:', err);
      // Mostrar mensaje de error al usuario
      if (err.response && err.response.data) {
        const errorMsg = err.response.data.message || err.response.data.error || 'Error al actualizar cierre mensual';
        alert(errorMsg);
      } else {
        alert('Error al actualizar cierre mensual');
      }
    }
  };
  const handleChange = (e) => setAnio(parseInt(e.target.value, 10));
  return (
    <div className="cierre-mensual">
      <h1>Cierre Mensual</h1>
      <label>Año: </label>
      <select value={anio} onChange={handleChange}>
        {[currentYear - 3, currentYear - 2, currentYear - 1, currentYear, currentYear + 1].map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
      <table className="cierre-table">
        <thead>
          <tr>
            <th>Mes</th>
            <th>Cerrado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {meses.map((name, idx) => (
            <tr key={idx + 1}>
              <td>{name}</td>
              <td className={estado[idx + 1] ? 'status-true' : 'status-false'}>
                {estado[idx + 1] ? 'Sí' : 'No'}
              </td>
              <td>
                <button onClick={() => toggleMes(idx + 1)}>
                  {estado[idx + 1] ? 'Abrir mes' : 'Cerrar mes'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CierreMensual;